export const getOAuthRedirectUri = () => {
    const envUri = process.env.REACT_APP_REDIRECT_URI
    if (typeof envUri === 'string' && envUri.trim() !== '') {
        return envUri.trim()
    }
    return window.location.origin
}

export const getOAuthAuthorizeUrl = () => {
    const params = new URLSearchParams({
        client_id: process.env.REACT_APP_CLIENT_ID,
        scope: 'read write',
        redirect_uri: getOAuthRedirectUri(),
        response_type: 'code',
        force_login: 'true',
    })

    return `https://makegayfriends.com/oauth/authorize?${params.toString()}`
}

export const getToken = async (code) => {
    const body = new URLSearchParams({
        grant_type: 'authorization_code',
        code,
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
        scope: 'read write',
        redirect_uri: getOAuthRedirectUri(),
    })

    const response = await fetch('https://makegayfriends.com/oauth/token', {
        method:"POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body,
    });
    const data = await response.json();
    return data
}

export const registerAuth = async ({register_data}) => {
    const postRegistration = async (token) => {
        const headers = token
            ? { 'Authorization': 'Bearer '+token, 'Content-Type': 'application/json' }
            : { 'Content-Type': 'application/json' }
        const response = await fetch('https://makegayfriends.com/api/v1/accounts', {method:"POST", headers, body: JSON.stringify(register_data)});
        const data = await response.json();
        return { response, data }
    }

    const getClientCredentialsToken = async () => {
        const body = new URLSearchParams({
            grant_type: 'client_credentials',
            client_id: process.env.REACT_APP_CLIENT_ID,
            client_secret: process.env.REACT_APP_CLIENT_SECRET,
            scope: 'read write',
        })

        const response = await fetch('https://makegayfriends.com/oauth/token', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body,
        })

        const data = await response.json()
        return data?.access_token
    }

    const fallbackToken = process.env.REACT_APP_ACCESS_TOKEN
    let { response, data } = await postRegistration(fallbackToken)

    const isRevokedOrUnauthorized =
        response.status === 401 ||
        response.status === 403 ||
        /revoked|invalid.?token|unauthorized/i.test(String(data?.error || ''))

    if (isRevokedOrUnauthorized) {
        const freshToken = await getClientCredentialsToken()
        if (typeof freshToken === 'string' && freshToken.trim() !== '') {
            const retry = await postRegistration(freshToken)
            response = retry.response
            data = retry.data
        }
    }

    return data
}

export const getRegister = async ({token, register_data}) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch('https://makegayfriends.com/api/v1/accounts', {method:"POST", headers, body: JSON.stringify(register_data)});
    const data = await response.json();
    return data
}

export const clearAuthStorage = () => {
    localStorage.removeItem('user')
    localStorage.removeItem('token')
}

export const clearAuthAndRedirect = (path = '/login') => {
    clearAuthStorage()
    window.location.replace(path)
}

export const getLogout = async () => {
    const token = localStorage.getItem('token')
    const appToken = process.env.REACT_APP_ACCESS_TOKEN

    try {
        const isValidToken = typeof token === 'string' && token.trim() !== ''
        const isSharedAppToken = isValidToken && typeof appToken === 'string' && token === appToken

        if (isValidToken && !isSharedAppToken) {
            const body = new URLSearchParams({
                client_id: process.env.REACT_APP_CLIENT_ID,
                client_secret: process.env.REACT_APP_CLIENT_SECRET,
                token: token,
            })

            await fetch('https://makegayfriends.com/oauth/revoke', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body,
            })
        }
    } catch (error) {
        console.error('Logout revoke failed:', error)
    } finally {
        clearAuthAndRedirect('/login')
    }
    /*
    const response = await fetch('https://api.bacpac.io/mkgf/logout', { method:"POST", body:JSON.stringify({token:token}) });
    const data = await response.json();
    console.log(response)
    if(response.status === 200){
        console.log(data)
    }
    return data
    */
}

export const verifyAuth = async (token) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch('https://makegayfriends.com/api/v1/accounts/verify_credentials', { headers });
    const data = await response.json();
    return data
}